import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import PlusXMiceIdModel from '../../../models/PlusXMiceIdModel';

export default async function getAdminTokenApi(
  plusId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/plusXMiceId/getPlusXMiceId?plusId=${plusId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return PlusXMiceIdModel(_ret.data?.data);
  } catch (error) {
    console.log('Error getAdminTokenApi', error);
    throw error;
  }
}
